import { RemoteSourceAutoComplete } from 'components/RemoteSourceAutoComplete';
import apiEndpoints from 'constants/endpoints';
import React from 'react';

export const PlayerSelect = ({ onChange, playerId, disabled = false, placeholder = 'Select Player', params = {} }) => {
  return (
    <RemoteSourceAutoComplete
      apiPath={apiEndpoints.players}
      queryParams={{
        ...params,
        limit: 50
      }}
      selectedId={playerId}
      disabled={disabled}
      getOptionLabel={(option => `${option.firstName} ${option.lastName} (${option.id})`)}
      onChange={onChange}
      placeholder={placeholder}
    />
  )
};
